// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"d0f5c25c","143":"afcf8962","144":"09bed87e","494":"ac4b0345","533":"d1e3c96e","651":"e5e47335","690":"d75e61bf","852":"7b4bc51e","940":"811a52c6"}[chunkId] + ".chunk.js";
};